"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrl = getUrl;
const adapter_core_1 = require("@aws-amplify/core/internals/adapter-core");
const getUrl_1 = require("../internal/getUrl");
function getUrl(contextSpec, input) {
    return (0, getUrl_1.getUrl)((0, adapter_core_1.getAmplifyServerContext)(contextSpec).amplify, input);
}
